import { useState } from "react"
import { useTranslation } from "react-i18next";

export default function AddReview(props){

    const [name, setName] = useState(props.record.name);
    const [text, setText] = useState(props.record.text);
    const { t } = useTranslation();
    function changeName(e){
        setName(e.target.value);
    }

    function changeText(e){
        setText(e.target.value);
    }
    function saveRecord(){
        props.saveRecord({id:props.record.id, name:name, text:text});
        props.closeWindow();
    }
    

    return(
        <>
            <div className="modal-window">
                <div id="add-review">
                    <div id='field'>
                        <label>Name:</label>
                        <input value={name} onChange={changeName}/>
                    </div>
                    <div id='field'>
                        <label>Text:</label>
                        <textarea value={text} onChange={changeText}/>
                    </div>
                    <div className="buttons-block">
                        <div onClick={saveRecord} className="add-button">Save</div>
                        <div onClick={props.closeWindow} className="delete-button">{t('Fermer')}</div>
                    </div>
                </div>
            </div>
        </>
    )
}